import React, { useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button'

const BootstrapModal = ({ headerText,children,size,visible,onHide }) => {

    const footer = (
        <div>
            {/* <Button label={buttonLabel} onClick={onSaveButtonClick} /> */}
            {/* <Button label="No" icon="pi pi-times" onClick={onHide} /> */}
        </div>
    );

    return (
        <>
            {/* <Button label="Show" icon="pi pi-external-link" onClick={() => onClick('displayBasic')} /> */}
            <Dialog header={headerText}  visible={visible} style={{ width: size+'vw' }} modal onHide={onHide}>
                {children}
            </Dialog>
        </>

    )
}

BootstrapModal.defaultProps = {
    size: "60",
    
  }
    

export default BootstrapModal